import { PropsWithChildren } from 'react';
import { CorporateFooter } from './CorporateFooter';
import { CorporateHeader } from './CorporateHeader';
import { CorporateLayout } from './CorporateLayout';
import './corporate-shell.css';

const ENVIRONMENT_LABEL = 'PRODUÇÃO';
const ACTIVE_ORGANIZATION = 'ARANOX';

export const CorporateShell = ({ children }: PropsWithChildren) => (
  <div
    className="arx-corporate-shell"
    data-aranox-shell="corporate"
    data-aranox-environment="production"
    data-aranox-organization={ACTIVE_ORGANIZATION.toLowerCase()}
  >
    <a className="arx-corporate-shell__skip-link" href="#arx-main-application">
      Ir para o conteúdo principal
    </a>

    <CorporateHeader activeOrganization={ACTIVE_ORGANIZATION} />

    <div
      className="arx-corporate-shell__environment"
      role="status"
      aria-label={`Ambiente ${ENVIRONMENT_LABEL}`}
    >
      <span
        className="arx-corporate-shell__environment-dot"
        aria-hidden="true"
      />
      <span>ARANOX</span>
      <span
        className="arx-corporate-shell__environment-separator"
        aria-hidden="true"
      >
        /
      </span>
      <span>{ENVIRONMENT_LABEL}</span>
    </div>

    <CorporateLayout>{children}</CorporateLayout>
    <CorporateFooter />
  </div>
);
